import React, { useEffect, useState } from "react";
import Drawer from "react-modern-drawer";

const MOBILE_MEDIA_QUERY = "(max-width: 767.98px)";
const canUseMatchMedia = typeof window !== "undefined" && typeof window.matchMedia === "function";

export default function DrawerComponent({ isOpen, onClose, children }) {
    const [isMobile, setIsMobile] = useState(() => (canUseMatchMedia ? window.matchMedia(MOBILE_MEDIA_QUERY).matches : false));

    useEffect(() => {
        if (!canUseMatchMedia) {
            return undefined;
        }
        const media = window.matchMedia(MOBILE_MEDIA_QUERY);
        const onChange = (event) => setIsMobile(event.matches);

        // Support both modern and older browser listener APIs.
        if (media.addEventListener) {
            media.addEventListener("change", onChange);
            return () => media.removeEventListener("change", onChange);
        }

        media.addListener(onChange);
        return () => media.removeListener(onChange);
    }, []);

    return (
        <Drawer
            open={isOpen}
            onClose={onClose}
            direction={isMobile ? "bottom" : "right"}
            className={isMobile ? "w-100 d-block no-scroll-bar" : "w-25 d-block no-scroll-bar"}
            style={isMobile ? { overflow: "scroll", height: "93%" } : { overflow: "scroll" }}
        >
            {children}
        </Drawer>
    );
}
